import styled, { css, keyframes } from "styled-components";

interface GlitchTextProps {
  children: string | number;
  className?: string;
}
const GlitchText = ({ children, className }: GlitchTextProps) => (
  <GlitchEffect className={className} data-text={children}>
    {children}
  </GlitchEffect>
);

/**
 * Converted to Styled Components
 * Original: Glitching Text by Isaac Doud
 * https://codepen.io/cipherbeta/pen/YLdVjw
 */

const randomNum = (max: number = 100, min: number = 0) =>
  Math.random() * (max - min) + min;

const getRandomGlitch = (step: number, totalSteps: number) => `
  ${Math.round(step * (1 / totalSteps) * 100)}% {
    clip: rect(${randomNum(1)}em, 9999px, ${randomNum(1)}em, 0);
    transform: skew(${randomNum(1)}deg);
  }
`;

const getRandomSkew = (step: number, totalSteps: number) => `
  ${Math.round(step * (1 / totalSteps) * 100)}% {
    transform: skew(${randomNum(10) - 5}deg);
  }
`;

const glitchCopy = css`
  content: attr(data-text);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const glitchAnim = () => {
  const steps = 20;
  let glitchAnimCSS = "";

  for (let i = 1; i < steps; i++) {
    glitchAnimCSS += getRandomGlitch(i, steps);
  }
  return keyframes`
    ${glitchAnimCSS}
  `;
};

const glitchAnim2 = () => {
  const steps = 20;
  let glitchAnimCSS = "";

  for (let i = 1; i < steps; i++) {
    glitchAnimCSS += getRandomGlitch(i, steps);
  }
  return keyframes`
    ${glitchAnimCSS}
  `;
};

const glitchSkew = () => {
  const steps = 10;
  let glitchAnimCSS = "";

  for (let i = 1; i < steps; i++) {
    glitchAnimCSS += getRandomSkew(i, steps);
  }
  return keyframes`
    ${glitchAnimCSS}
  `;
};

const GlitchEffect = styled.div`
  --divergence: 0.01em;
  position: relative;
  animation: ${glitchSkew} 1s infinite linear alternate-reverse;

  &::before {
    ${glitchCopy};
    left: var(--divergence);
    text-shadow: calc(var(--divergence) * -1) 0 var(--error-glitch-color-1);
    clip: rect(44px, 450px, 56px, 0);
    animation: ${glitchAnim} 5s infinite linear alternate-reverse;
  }

  &::after {
    ${glitchCopy};
    left: calc(var(--divergence) * -1);
    text-shadow: calc(var(--divergence) * -1) 0 var(--error-glitch-color-2),
      var(--divergence) var(--divergence) var(--error-glitch-color-1);
    animation: ${glitchAnim2} 1s infinite linear alternate-reverse;
  }
`;

export default GlitchText;
